function InsurerMeedyVO(id, idParentInsurer, companyName, address,
                   billingAddress, billingData, phone, fax, email, www, type, nip, regon,
                   billNumber, lastBillDate, footer, billingType, parentBillingType, logo, logoScanStatus, contractNumber,
                   contractSigningDate, contractTerminationDate, branches, transient_active, useBillingData, billingCompanyNameShort,
                   billingCompanyNameFull, billingNip, billingRegon) {

    this.id = id;
    this.idParentInsurer = idParentInsurer;
    this.companyName = companyName;
    this.address = address;
    this.billingAddress = billingAddress;
    this.billingData = billingData;
    this.billingType = billingType;
    this.billingCompanyNameShort = billingCompanyNameShort;
    this.billingCompanyNameFull = billingCompanyNameFull;
    this.parentBillingType = parentBillingType;
    this.billingRegon = billingRegon;
    this.billingNip = billingNip;
    this.phone = phone;
    this.fax = fax;
    this.email = email;
    this.www = www;
    this.nip = nip;
    this.regon = regon;
    this.type = type;
    this.billNumber = billNumber;
    this.lastBillDate = lastBillDate;
    this.footer = footer;
    this.logo = logo;
    this.logoScanStatus = logoScanStatus;
    this.contractNumber = contractNumber;
    this.contractSigningDate = contractSigningDate;
    this.contractTerminationDate = contractTerminationDate;
    this.branches = branches;
    this.transient_active = transient_active;
    this.useBillingData = useBillingData;

    var _typeContext = {
        branches : InsurerMeedyVO,
        address : AddressMeedyVO,
        billingAddress : AddressMeedyVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
